import * as yup from 'yup';
import { TEXTS } from '@/constants';

const {
  ERRORS: { NO_SPECIAL_CHARACTERS, FIELD_CHARACTER_MAX, MUST_CONTAIN_LETTER, IS_REQUIRED },
} = TEXTS;

const noSpecialCharsRegex = /^[A-Za-z\-–—' ]*$/;
const onlyLettersRegex = /[A-Za-z]/;

const verifyInfoValidation: { [key: string]: any } = {
  firstName: yup
    .string()
    .required(IS_REQUIRED('First name'))
    .test({
      name: 'checkSpecialCharacter',
      message: NO_SPECIAL_CHARACTERS,
      test: (value) => noSpecialCharsRegex.test(value),
    })
    .test({
      name: 'checkLetterCharacter',
      message: MUST_CONTAIN_LETTER('First name'),
      test: (value) => onlyLettersRegex.test(value),
    })
    .max(25, FIELD_CHARACTER_MAX('First Name', 25)),
  lastName: yup
    .string()
    .required(IS_REQUIRED('Last name'))
    .test({
      name: 'checkSpecialCharacter',
      message: NO_SPECIAL_CHARACTERS,
      test: (value) => noSpecialCharsRegex.test(value),
    })
    .test({
      name: 'checkLetterCharacter',
      message: MUST_CONTAIN_LETTER('Last name'),
      test: (value) => onlyLettersRegex.test(value),
    }),
};

export const getOneClickSchemaValidation = (): yup.Schema<any> => {
  const validationSchema = yup.object(verifyInfoValidation);
  return validationSchema;
};
